// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification__2S5BO","isHidden":"isHidden__2S5BO"};